// extracted by mini-css-extract-plugin
export var evenement = "detailsEvent-module--evenement--5caa2";
export var eventFooter = "detailsEvent-module--event-footer--c5047";
export var eventFooterAuthor = "detailsEvent-module--event-footer-author--ddd4f";
export var eventFooterBack = "detailsEvent-module--event-footer-back--258e4";
export var eventFooterDate = "detailsEvent-module--event-footer-date--87a8f";
export var eventFooterRight = "detailsEvent-module--event-footer-right--6f3dc";
export var eventImg = "detailsEvent-module--event-img--30d33";
export var eventPlace = "detailsEvent-module--event-place--eecf2";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--45816";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--f7114";
export var eventsItemDate = "detailsEvent-module--events-item-date--93ca5";
export var eventsItemDateMonth = "detailsEvent-module--events-item-date-month--aa279";
export var eventsItemDateTo = "detailsEvent-module--events-item-date-to--07f11";
export var eventsItemDateYear = "detailsEvent-module--events-item-date-year--452b6";
export var eventsItemTaxo = "detailsEvent-module--events-item-taxo--0d162";
export var eventsItemTitle = "detailsEvent-module--events-item-title--cd0b8";
export var pageEvent = "detailsEvent-module--page-event--41c44";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--92d65";
export var socialPanelContainer = "detailsEvent-module--social-panel-container--0a0d5";